import mountReal from './mountReal'
import mountTrial from './mountTrial'
import defaultValues from './defaultValues'
import billingDayText from './billingDayText'
import typeCompany from './typeCompany'
import tableGrid from './tableGrid'

const preRegistrations = {
  defaultValues,
  mountReal,
  mountTrial,
  billingDayText,
  typeCompany,
  tableGrid,
}

export default preRegistrations
